<template>
  <div id="visitas-no-mes">
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Visitas no mês"
            description="Visitas realizadas nos últimos 30 dias"
            url="/visitas-domiciliares"
          />
        </div>
      </div>
      <tabela-atendimentos
        :loadingPage="loadingPage"
        :atendimentos="atendimentos"
        :profissional="profissional"
      ></tabela-atendimentos>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import utils from '@/mixins/utils.js'
import TabelaAtendimentos from './TabelaAtendimentos'

export default {
  name: 'VisitasNoMes',
  metaInfo: {
    title: 'Visitas no mês',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    TabelaAtendimentos,
  },
  mixins: [utils],
  computed: {},
  data() {
    return {
      periodoInicial: '',
      periodoFinal: '',
      loadingPage: false,
      profissional: null,
      atendimentos: [],
    }
  },
  methods: {
    async buscarDados() {
      try {
        this.loadingPage = true

        const inicio = this.periodoInicial.replaceAll('-', '')
        const fim = this.periodoFinal.replaceAll('-', '')

        let idFicha = 8
        let cod = this.$store.state.cos_dim_prof

        const response = await this.$api.get(
          `/app/relatorio-atendimentos/${this.$store.state.cod_ibge}/profissional/${cod}/${idFicha}/${inicio}/${fim}`
        )
        if (response) {
          this.profissional = {
            no_profissional: this.$store.state.username,
            co_dim_profissional: this.$store.state.cos_dim_prof,
            id_ficha: idFicha,
          }
          this.atendimentos = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingPage = false
      }
    },

    carregarDatas() {
      const hoje = new Date()
      const menos90 = new Date()
      menos90.setDate(menos90.getDate() - 30)

      const formatar = (d) => {
        const ano = d.getFullYear()
        const mes = String(d.getMonth() + 1).padStart(2, '0')
        const dia = String(d.getDate()).padStart(2, '0')
        return `${ano}-${mes}-${dia}`
      }

      this.periodoFinal = formatar(hoje)
      this.periodoInicial = formatar(menos90)
    },
  },
  created() {
    this.carregarDatas()
    this.buscarDados()
  },
}
</script>

<style lang="scss" scoped>
#visitas-no-mes {
  .btn-filter {
    margin-top: 30px;
  }
  .filter-select {
    margin: 0;
  }
}
</style>

<style scoped>
#visitas-no-mes .v-select {
  min-width: 300px;
}
@media screen and (max-width: 656px) {
  #visitas-no-mes .v-select {
    width: 100%;
  }
}
</style>
